import Title from './title'

export default function Location({ studio }) {
  const t = useI18n()
  return (
    <div className='px-5'>
      <Title>{t('page:joinUs.location')}</Title>
      <div className='font-normal tracking-widest mt-2'>
        <RowAddress iconKey='locationF' content={ studio.address || 'NA' } />
        <Row iconKey='officeF' content={ studio.traffic || 'NA' } />
      </div>
    </div>
  )
}

const Row = ({ content, iconKey }) => (
  <div className='flex space-x-2 items-start py-2'>
    <div className='text-gray-400'>{ icon(iconKey) }</div>
    <div className='text-sm font-medium' { ...content.rawHtml() }/>
  </div>
)

const RowAddress = ({ content, iconKey }) => {
  const t = useI18n()
  return (
    <div className='flex space-x-2 items-start py-2'>
      <div className='text-gray-400'>{ icon(iconKey) }</div>
      <div className='text-sm font-medium'>
        { content }
      </div>
      <div className='shrink-0 text-xs pt-[0.18rem] font-bold underline'>
        { h.mapUrl(t('common:openMap'), content) }
      </div>
    </div>
  )
}
